// extracted by mini-css-extract-plugin
export default {"benefits-wrap":"benefits_benefits-wrap__WGRtB","benefit":"benefits_benefit__yONB3","benefit-icon":"benefits_benefit-icon__+Ahcz"};